import { createContext, useContext, ReactNode } from 'react';
import { useWallpapers, Wallpaper } from '../hooks/useWallpapers';

interface WallpapersContextType {
  wallpapers: Wallpaper[];
  loading: boolean;
  deleteWallpaper: (filename: string) => Promise<void>;
  saveWallpaper: (blob: Blob) => Promise<string | null>;
  loadWallpapers: () => Promise<void>;
  countWallpapers: () => Promise<number>;
}

const WallpapersContext = createContext<WallpapersContextType | null>(null);

export function WallpapersProvider({ children }: { children: ReactNode }) {
  const wallpapersState = useWallpapers();

  return (
    <WallpapersContext.Provider value={wallpapersState}>
      {children}
    </WallpapersContext.Provider>
  );
}

export function useWallpapersContext() {
  const context = useContext(WallpapersContext);
  if (!context) {
    throw new Error('useWallpapersContext must be used within a WallpapersProvider');
  }
  return context;
}
